
const TableauFrais = function(element, options) {
    this.element  = $(element);
    this.options  = options;

    // Gestion du filtrage
    this.filtre = $.extend({}, this.options.filtre);

    this.btnFiltre = $(this.options.button.filter);
    this.btnRefresh  = $(this.options.button.refresh);
    this.btnSemainePrev = $(this.options.button.semainePrev);
    this.btnSemaineNext = $(this.options.button.semaineNext);

    this.semaine = $(this.options.semaineCourante);

    this.btnFiltre.on('form-success.modal', $.proxy(this.onFiltreSuccess, this));
    this.btnSemainePrev.on('click', $.proxy(this.onSemainePrevClick, this));
    this.btnSemaineNext.on('click', $.proxy(this.onSemaineNextClick, this));
    this.btnRefresh.on('click', $.proxy(this.onRefreshClick, this));

    $(document).on('click', this.options.button.reset, $.proxy(this.onResetClick, this));

    // Import
    this.element.on('form-success.modal', '[data-import]', $.proxy(this.onImportSuccess, this));
    // Delete
    this.element.on('form-success.modal', '[data-delete]', $.proxy(this.onImportSuccess, this));

    // Collapse show
    this.element.on('show.bs.collapse', '.collapse', $.proxy(this.onCollapseShow, this));
    this.element.on('show.bs.collapse', '[data-url]:empty', $.proxy(this.onDetailShow, this));
};


$.extend(TableauFrais.prototype, {
    onImportSuccess: function(event) {
        event.preventDefault();
        event.modal.hide();

        this.refreshTableau();
    },

    onCollapseShow: function() {
        this.element.find('.in, .collapsing').collapse('hide');
    },

    onDetailShow: function(event) {
        const detail = $(event.currentTarget);

        event.preventDefault();

        this.showDetail(detail);
    },

    showDetail: function(detail) {

        $.ajax({
            url: detail.attr('data-url'),
            success: response => {
                detail.html(response);

                detail.collapse('show');
            }
        })
    },

    refreshTableau: function() {
        this.element.addClass('loading');

        // Preserve detail row state
        let active = this.element.find('.collapse.in').attr('id');

        $.ajax({
            url: Routing.generate('tableau_frais_tableau'),
            data: this.filtre,
            success: response => {
                this.element.removeClass('loading');

                this.element.html(response);
                if (active) {
                    this.element.find('#' + active).collapse('show');
                }
            }
        });

        let date = moment(this.filtre.date, 'DD/MM/YYYY');
        let filtre = 'S' + date.format('WW');

        this.semaine.text(filtre);
    },

    onRefreshClick: function(event) {
        event.preventDefault();

        this.refreshTableau();
    },

    onResetClick: function() {
        this.filtre = $.extend({}, this.defaut);

        $.ajax({
            url: Routing.generate('tableau_frais_reset'),
            success: response => {
                this.filtre = response;

                this.refreshTableau();
            }
        })
    },

    onFiltreSuccess: function(event, response) {
        this.filtre = response;

        this.refreshTableau();
    },

    onSemainePrevClick: function(event) {
        event.preventDefault();

        let date = moment(this.filtre.date, 'DD/MM/YYYY').subtract('1', 'weeks');

        this.filtre.date = date.format('DD/MM/YYYY');
        // this.filtre.sdate = date.format('WW');

        this.refreshTableau();
    },

    onSemaineNextClick: function(event) {
        event.preventDefault();

        let date = moment(this.filtre.date, 'DD/MM/YYYY').add('1', 'weeks');

        this.filtre.date = date.format('DD/MM/YYYY');
        // this.filtre.sdate = date.format('WW');

        this.refreshTableau();
    }
});

$.fn.tableauFrais = function(options) {
    return $.each(this, function () {
        new TableauFrais(this, options);
    })
};


// WEBPACK FOOTER //
// ./js/form/tableauFrais.js